import { BigDataObjectConstants } from "../../constants/big-data-object-constants";
import { CopConstants } from "../../constants/cop-constants";
import { BigDataHelper } from "../../helpers/big-data-helper";
import { DOMHelper } from "../../helpers/dom-helper";
import { BigData, ParamsDto, RecommendationDto } from "../../marketing-client-bigdata";
import { CollectionIdsObject, CtaObject, Utils } from "../utils";
import CopBox from "./cop-box";
import ReadLater from "./read-later";

export default class RecommendationsCop {
    cop: HTMLElement;
    isMobile: Boolean;
    ddboxIsVisible = false;
    boxes: Array<CopBox> = [];
    boxesToDownload: Array<boolean>;
    widgetId: string;
    scriptParameters: ParamsDto | undefined;
    recommendations: Array<RecommendationDto>;
    readLater: ReadLater;
    articleLoader: HTMLElement | null;
    collectionIdsObject: CollectionIdsObject;
    ctaObject: CtaObject;
    pageViewId: string;

    constructor(isMobile: Boolean) {
        this.isMobile = isMobile;
        this.readLater = new ReadLater(CopConstants.boxButtonsWrap);
    }

    init(ddboxIsVisible: boolean) {
        this.cop = DOMHelper.querySelector(CopConstants.cop) as HTMLElement;
        this.ddboxIsVisible = ddboxIsVisible;

        if (!this.cop) return;

        this.getAnalyticalParams();
        this.hideFirstBox();
        this.prepareDataToGetReco();
        this.initializeScriptParameters();
        this.pullRecommendations();
        this.readLater.init();
    }

    getAnalyticalParams() {
        if (this.cop?.parentElement) {
            this.collectionIdsObject = Utils.prepareCollectionIdsObject(this.cop.parentElement);
            this.ctaObject = Utils.prepareCtaObject(this.cop.parentElement);

            this.pageViewId = BigDataHelper.getBigDataOrCookieValue(
                BigDataObjectConstants.pageViewCookie,
                BigDataObjectConstants.pageViewBigData
            );
        }
    }

    prepareDataToGetReco(): void {
        this.boxesToDownload = JSON.parse(this.cop.getAttribute(CopConstants.dataDownloadArticle)!);
        this.widgetId = this.cop.getAttribute(CopConstants.dataWidgetId)!;
    }

    initializeScriptParameters() {
        const dataKeyValue = JSON.parse(this.cop.getAttribute(CopConstants.dataKeyValue)!);

        if (dataKeyValue) {
            this.scriptParameters = dataKeyValue.reduce((m: ParamsDto, v: ParamsDto) => {
                m[v.key] = v.value;
                return m;
            }, {});
        }
    }

    async pullRecommendations() {
        if (!this.widgetId) return;

        try {
            const recommendations = await BigData.getRecommendations(this.widgetId, this.scriptParameters);

            this.recommendations = [...recommendations];
            this.prepareBoxes(recommendations);
        } catch {
            console.log(CopConstants.fetchFailedMessage);
            this.prepareBoxes(null);
        }
    }

    prepareBoxes(recommendations: RecommendationDto[] | null) {
        let recoToUseIndex = 0;

        for (let i = 0; i < this.boxesToDownload.length; i++) {
            const box = new CopBox(i, this.boxesToDownload[i]);
            const recommendation = recommendations ? recommendations[recoToUseIndex] : null;

            this.createBox(box, recommendation);
            recoToUseIndex++;
        }
        this.showFirstBox();
        this.readLater.bindReadLaterEvents(this.boxes);
    }

    createBox(box: CopBox, recommendation: RecommendationDto | null) {
        box.init();
        box.imageFormat = box.assignImageFormat(this.ddboxIsVisible, this.isMobile);
        box.prepareBox(recommendation, this.ctaObject, this.collectionIdsObject, this.pageViewId);

        this.boxes.push(box);
    }

    hideFirstBox(): void {
        this.articleLoader = DOMHelper.querySelector(CopConstants.swimmerArticleLoader) as HTMLElement;
        this.articleLoader?.classList.add(CopConstants.visible);
        this.toggleContentVisibility(`${CopConstants.box}${0}`);
    }

    showFirstBox(): void {
        this.articleLoader?.classList.remove(CopConstants.visible);
        this.toggleContentVisibility(`${CopConstants.box}${0}`);
    }

    toggleContentVisibility(boxClass: string): void {
        const el = DOMHelper.querySelector(boxClass);

        el?.classList.toggle(CopConstants.hidden);
    }
}

export interface ArticleParameters {
    articleId: number;
    pageUrl: string;
}
